import { TimeUnitsEnum } from '@/services/dictionaries/TimeUnits';
import { TimeDelayInterface } from '@/store/campaignCreator/types';

import { forEach } from 'lodash-es';

//time is number of minutes in time unit
const timeUnits = [
    { name: TimeUnitsEnum.Days, time: 1440 },
    { name: TimeUnitsEnum.Hours, time: 60 },
    { name: TimeUnitsEnum.Minutes, time: 1 },
];

export const getTimeInUnits = (delay: number): TimeDelayInterface => {
    //changing time value to unit
    const timeDelay = { value: 0, unit: TimeUnitsEnum.Days };

    forEach(timeUnits, (timeUnit) => {
        if (delay % timeUnit.time !== 0) return;

        timeDelay.value = delay / timeUnit.time || 1;
        timeDelay.unit = timeUnit.name;
        return false;
    });
    return timeDelay;
};
